import { http } from "./config";

export default {
  meusMenus: () => http.get("menus/meus"),
  listar: () => http.get("menus"),
  criar: (payload) => http.post("menus", payload),
  atualizar: (id, payload) => http.put(`menus/${id}`, payload),
  excluir: (id) => http.delete(`menus/${id}`),
};
